/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Popular_PuzzlesInputs */

const en_control_popular_puzzles = /** @type {(inputs: Control_Popular_PuzzlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular puzzle answers`)
};

const zh_control_popular_puzzles = /** @type {(inputs: Control_Popular_PuzzlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门谜题答案`)
};

/**
* | output |
* | --- |
* | "Popular puzzle answers" |
*
* @param {Control_Popular_PuzzlesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_popular_puzzles = /** @type {((inputs?: Control_Popular_PuzzlesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Popular_PuzzlesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_popular_puzzles(inputs)
	return zh_control_popular_puzzles(inputs)
});
export { control_popular_puzzles as "control.popular_puzzles" }